import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import {
  EventTabs,
  IEventForm,
} from 'components/organisms/forms/event/EventForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { eventFormToQuery } from 'middleware/event/eventFormToQuery';
import { useTranslation } from 'react-i18next';
import { PiCalendar, PiIdentificationCard, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateEvent } from 'services/events';
import { ICreateEvent } from 'services/events/types';
import { STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const eventInitialValues: IEventForm = {
  version: 0,
  id: '',
  name: '',
  status: STATUS.draft,
  startDate: new Date().toISOString(),
  endDate: new Date().toISOString(),
  labels: [],
};

const CreateEvent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const createEvent = useCreateEvent();

  const mutateOptions = useMutateOptions<IEventForm>();

  const onCreateEvent = async (
    values: IEventForm,
    helpers: FormikHelpers<IEventForm>
  ) => {
    await createEvent.mutateAsync(eventFormToQuery(values), {
      ...mutateOptions(helpers),
      onSuccess: ({ id }) => navigate(`/event/${id}/labels`),
    });
  };

  return (
    <Form.Event
      i18nextPrefix='event'
      initialValues={{
        ...eventInitialValues,
      }}
      onSubmit={onCreateEvent}
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate('/event')}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
          <Button.Icon icon={<PiCalendar />} />
        </Button>
      }
      disableTabs={[EventTabs.balance]}
    />
  );
};

export default CreateEvent;
